export const buildSalesOrderFields = (salesOrder) => {
  if (!salesOrder) return []

  return [

    {
      label: "Pedido ERP",
      value: salesOrder.uid || "-"
    },
    {
      label: "Referencia",
      value: salesOrder.document_reference || "-"
    }
  ]
}